import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { requestPasswordReset } from '../services/api';
import { AuthShell, FIELD, FOOTLINK, FOOTNOTE, LABEL, PRIMARY } from './auth/AuthShell';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      // The green box below IS the confirmation. A toast saying the same thing
      // a second time reads as two emails on their way, not one.
      await requestPasswordReset(email);
      setSent(true);
    } catch {
      toast.error('That did not go through. Check the address and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  let submitLabel = 'Send me a reset link';
  if (isSubmitting) submitLabel = 'Sending';

  return (
    <AuthShell
      title={<>Forgot your password?<br /><span className="text-[#92949d]">One email fixes it.</span></>}
      sub="Give the address your company knows you by. The link in the email lets you choose a new password."
    >
      {sent && (
        <div className="rounded-md border border-[#dfe9d6] bg-[#f3f9ef] px-3 py-2.5 text-[13px] text-[#3f7a2f]">
          If that address has an account, the email is on its way. It can take a minute.
        </div>
      )}
      {!sent && (
        <form onSubmit={handleSubmit} className="flex flex-col gap-4" noValidate>
          <div>
            <label htmlFor="forgot-email" className={LABEL}>Work email</label>
            <input id="forgot-email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" required className={FIELD} />
          </div>
          <button type="submit" disabled={isSubmitting || !email} className={PRIMARY}>{submitLabel}</button>
        </form>
      )}
      <p className={FOOTNOTE}>Remembered it? <Link to="/login" className={FOOTLINK}>Sign in</Link>.</p>
    </AuthShell>
  );
};

export default ForgotPassword;
